module.exports = __webpack_public_path__ + "img/_SDI9254-1600.53246efd.webp";